function BlockHeading({name}: {name: string}) {
    return <h3 className="pb-5 text-[22px] font-extrabold leading-[25px] text-primary">{name}</h3>;
}

export default BlockHeading;
